import React from 'react';
import CancelCase from "./CancelCase";
import SplitButton from './SplitButton';

const CaseCancelPopup = ({
                             documentTypes,
                             refreshCaseFiles,
                             documentTypesForEditor,
                             hideRequireCaseCancellationButtonInternal,
                             hideRequireCaseCancellationButton,
                             userId,
                             objectOwner,
                             users,
                             barcode,
                             caseInfo,
                             permitTypeTitle,
                             exploitationIdentificationTemplateString,
                             ownerIdentificationTemplateString,
                             userAddress
                         }) => {

    const renderDocumentComponent = (doc) => {
        switch (doc.documentTypeStatus) {
            case 8:
                return (
                    !hideRequireCaseCancellationButton && (
                        <CancelCase
                            onFileAdded={refreshCaseFiles}
                            Disabled={!hideRequireCaseCancellationButtonInternal}
                            documentTypes={documentTypesForEditor}
                            docType={doc}
                            objectOwner={objectOwner}
                            buttonTitle={doc.name}
                            userId={userId}
                            barcode={barcode}
                            caseInfo={caseInfo}
                            users={users}
                            permitTypeTitle={permitTypeTitle}
                            ownerIdentificationTemplateString={ownerIdentificationTemplateString}
                            exploitationIdentificationTemplateString={exploitationIdentificationTemplateString}
                            userAddress={userAddress}
                        />
                    )
                );


            default:
                return null;
        }
    };

    return (
        <div>
            <SplitButton
                options={documentTypes}
                renderDocumentComponent={renderDocumentComponent}
                buttonLabel="ნებართვის ძალადაკარგულად გამოცხადების აქტი"
                buttonType={3}
            />
        </div>
    );
};

export default CaseCancelPopup;
